import React, { FunctionComponent } from 'react';
import {
	Card,
	Paragraph,
	Text,
	Table,
	TableHead,
	TableRow,
	TableHeaderCell,
	TableBody,
	TableCell,
} from '@mlc/web-ui-toolkit';
import { Member } from '../../../../../logic/domains/planProfile.domain';
import planProfileTestIds from '../PlanProfile.elements';

type Props = {
	members: Member[];
};

const PolicyCommitteeMembers: FunctionComponent<Props> = ({ members }) => {
	return members.length > 0 ? (
		<>
			<Text fontWeight="semibold" marginTop={6} marginBottom={4} el="h5">
				Policy Committee Members
			</Text>

			<Table
				variant="bottomLines"
				border="mlcBorderThin"
				borderColor="mlcAlmostWhite"
				layout="fixed"
			>
				<TableHead>
					<TableRow>
						<TableHeaderCell>Name</TableHeaderCell>
						<TableHeaderCell>Role</TableHeaderCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{members.map((member, idx) => (
						<TableRow
							key={idx}
							data-id={planProfileTestIds.planPolicyCommitteeMembers}
						>
							<TableCell>{member.name}</TableCell>
							<TableCell>{member.role}</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</>
	) : null;
};

export default PolicyCommitteeMembers;
